// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__5bV36","poweredBy":"styles_poweredBy__1McoZ","result":"styles_result__89PKm"};